import { render, staticRenderFns } from "./check.vue?vue&type=template&id=50f15b08&"
import script from "./check.vue?vue&type=script&lang=js&"
export * from "./check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f15b08')) {
      api.createRecord('50f15b08', component.options)
    } else {
      api.reload('50f15b08', component.options)
    }
    module.hot.accept("./check.vue?vue&type=template&id=50f15b08&", function () {
      api.rerender('50f15b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/check.vue"
export default component.exports